"use client";

import { TopBadgesProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/TopBadges/TopBadgesProps";
import { useGetProductTileClickImpressions } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useGetProductTileClickImpressions";
import { TopBadges as TopBadgesInternal } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/TopBadges";
import React from "react";

export const TopBadges = ({
  data: { showEventBadge, topBadge, hideBadge, productToken, badgeList },
}: {
  data: TopBadgesProps;
}) => {
  const { recordProductBadgeViewEvent } = useGetProductTileClickImpressions({
    token: productToken,
    badgeList,
  });

  if (hideBadge) {
    return null;
  }

  return (
    <TopBadgesInternal
      key="top-badges"
      tileBadge={topBadge}
      showEventBadge={showEventBadge}
      onTopLeftBadgeVisible={recordProductBadgeViewEvent}
    />
  );
};
